import { SearchMaskGroupType, } from 'ltur-state-engine';
import Vue from 'vue-ltur';
var InputValueMapper = /** @class */ (function () {
    function InputValueMapper() {
    }
    InputValueMapper.groupSingleHandlingDepartureAirport = function (inputValue, lastChosen, departureAirportGroups) {
        if (lastChosen.id !== void 0) {
            var airportGroup = lastChosen;
            var departureAirportsIndex = departureAirportGroups.map(function (e) { return e.id; }).indexOf(airportGroup.id);
            var airports = departureAirportGroups[departureAirportsIndex].airports;
            for (var inputValueIndex = 0; inputValueIndex < inputValue.value.length; inputValueIndex++) {
                if (airports.map(function (e) { return e.code; }).indexOf(inputValue.value[inputValueIndex].code) !== -1) {
                    inputValue.value.splice(inputValueIndex, 1);
                    inputValueIndex--;
                }
            }
        }
        if (lastChosen.code !== void 0) {
            var airport = lastChosen;
            for (var inputValueIndex = 0; inputValueIndex < inputValue.value.length; inputValueIndex++) {
                if (inputValue.value[inputValueIndex].id !== void 0) {
                    var airportGroup = inputValue.value[inputValueIndex];
                    var departureAirportsIndex = departureAirportGroups.map(function (e) { return e.id; }).indexOf(airportGroup.id);
                    var airports = departureAirportGroups[departureAirportsIndex].airports;
                    if (airports.map(function (e) { return e.code; }).indexOf(airport.code) !== -1) {
                        inputValue.value.splice(inputValueIndex, 1);
                        inputValueIndex--;
                    }
                }
            }
        }
    };
    InputValueMapper.uniqueDepartureAirport = function (result, lastChosen, toggle) {
        var exists = false;
        var index = -1;
        if (lastChosen.id !== void 0) {
            var airportGroup = lastChosen;
            if (result.map(function (e) { return e.id; }).indexOf(airportGroup.id) !== -1) {
                exists = true;
                index = result.map(function (e) { return e.id; }).indexOf(airportGroup.id);
            }
        }
        if (lastChosen.code !== void 0) {
            var airport = lastChosen;
            if (result.map(function (e) { return e.code; }).indexOf(airport.code) !== -1) {
                exists = true;
                index = result.map(function (e) { return e.code; }).indexOf(airport.code);
            }
        }
        if (!exists) {
            result.push(lastChosen);
        }
        if (toggle !== void 0 && toggle && exists) {
            result.splice(index, 1);
        }
    };
    InputValueMapper.departureAirportUIValue = function (inputValue, departureAirportGroups, searchMaskGroupType) {
        var count = 0;
        for (var resultIndex = 0; resultIndex < inputValue.value.length; resultIndex++) {
            if (inputValue.value[resultIndex].id !== void 0) {
                var airportGroup = inputValue.value[resultIndex];
                var departureAirportsIndex = departureAirportGroups.map(function (e) { return e.id; }).indexOf(airportGroup.id);
                var airports = departureAirportGroups[departureAirportsIndex].airports;
                count += airports.length;
            }
            if (inputValue.value[resultIndex].code !== void 0) {
                count++;
            }
        }
        if (count > 0) {
            inputValue.uiValue = Vue.translate('selected_departure_airports', count, { "count": count });
        }
        else {
            if (searchMaskGroupType == SearchMaskGroupType.FLIGHT) {
                inputValue.uiValue = Vue.translate('search_mask.input_type.please_select');
            }
            else {
                inputValue.uiValue = Vue.translate('any');
            }
        }
    };
    InputValueMapper.getDepartureAirportSearchResult = function (searchKey, departureAirportGroups, excludeList, result) {
        for (var departureAirportGroupsIndex = 0; departureAirportGroupsIndex < departureAirportGroups.length; departureAirportGroupsIndex++) {
            var airportGroup = departureAirportGroups[departureAirportGroupsIndex];
            var airports = airportGroup.airports;
            if (airportGroup.name.search(new RegExp(searchKey, "i")) !== -1
                && excludeList.map(function (e) { return e.id; }).indexOf(airportGroup.id) === -1) {
                result.push(airportGroup);
            }
            for (var airportsIndex = 0; airportsIndex < airports.length; airportsIndex++) {
                var airport = airports[airportsIndex];
                if (airport.name.search(new RegExp(searchKey, "i")) !== -1
                    || airport.code.search(new RegExp(searchKey, "i")) !== -1
                        && excludeList.map(function (e) { return e.code; }).indexOf(airport.code) === -1) {
                    result.push(airport);
                }
            }
        }
    };
    InputValueMapper.copyArrayOfObjects = function (origin, target) {
        for (var i = 0; i < origin.length; i++) {
            target[i] = {};
            for (var prop in origin[i]) {
                target[i][prop] = origin[i][prop];
            }
        }
        return target;
    };
    InputValueMapper.range = function (min, max) {
        var array = [];
        var j = 0;
        for (var i = min; i <= max; i++) {
            array[j] = i;
            j++;
        }
        return array;
    };
    InputValueMapper.getTravellersUIValue = function (numberOfAdults, numberOfChildren) {
        var adultKey = numberOfChildren === 0 ? 'adults_pluralized' : 'adults_short';
        var adultText = Vue.translate(adultKey, numberOfAdults, { "count": numberOfAdults });
        var childrenText = Vue.translate('children_pluralized', numberOfChildren, { "count": numberOfChildren });
        return numberOfChildren === 0 ? adultText : adultText + ' ' + childrenText;
    };
    InputValueMapper.toggleArrayLength = function (length, arrayParam, valueParam) {
        if (arrayParam.length > length) {
            var numberOfElements = arrayParam.length - length;
            var startIndex = length;
            arrayParam.splice(startIndex, numberOfElements);
        }
        if (arrayParam.length < length) {
            var numberOfElements = length - arrayParam.length;
            var startIndex = length - numberOfElements;
            var value = (valueParam !== void 0) ? valueParam : null;
            for (var i = 0; i < numberOfElements; i++) {
                arrayParam.splice(startIndex, 0, value);
                startIndex++;
            }
        }
        return arrayParam;
    };
    return InputValueMapper;
}());
export default InputValueMapper;
